// @flow
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import mapProps from 'recompose/mapProps';
import type { HOC } from 'recompose';
import type { Sub } from '../Tariff';


type Props = {
  confirmationState: string,
  sub: Sub,
  beginEditInformers: (void) => void,
  stopEditInformers: (void) => void,
  handleSaveInformers: (void) => void,
};

const buttonsState: HOC<*, Props> = compose(
  withState('buttons', 'setButtons', ({ sub }) => (sub ? ['pause', 'settings'] : ['tariff'])),


  withHandlers({
    // Изменить, отключить, отмена
    handleSettings: ({ setButtons }) => (e) => {
      e.preventDefault();
      setButtons(['change', 'stop', 'cancel']);
    },
    // Сохранить, отмена
    handleChange: ({ setButtons, beginEditInformers }) => (e) => {
      e.preventDefault();
      setButtons(['save', 'cancel']);
      beginEditInformers();
    },
    // Возврат на уровень выше
    handleCancel: ({ setButtons, buttons, stopEditInformers }) => (e) => {
      e.preventDefault();
      if (buttons.includes('save')) {
        setButtons(['change', 'stop', 'cancel']);
        stopEditInformers();
        return;
      }
      if (buttons.includes('connect')) {
        setButtons(['tariff']);
        stopEditInformers();
        return;
      }
      if (buttons.includes('change')) {
        setButtons(['pause', 'settings']);
      }
    },
    // Сохранение, возврат обратно в "настроить"
    handleSave: ({ setButtons, handleSaveInformers }) => (e) => {
      e.preventDefault();
      setButtons(['change', 'stop', 'cancel']);
      handleSaveInformers();
    },
    // Редактирование перед подключением
    handleConnectChange: ({ setButtons, beginEditInformers }) => (e) => {
      e.preventDefault();
      setButtons(['connect', 'cancel']);
      beginEditInformers();
    },

  }),


  mapProps((props) => {
    if (props.confirmationState) {
      return ({
        ...props,
        buttons: [props.confirmationState],
      });
    }
    if (props.sub && props.sub.pay_ready && props.buttons.includes('settings')) {
      return ({
        ...props,
        buttons: ['payready', 'pause', 'settings'],
      });
    }
    return props;
  })

);

export default buttonsState;
